// Guide Block Types:
// - "section": { id: string, title: string, content: []}
// - "subsection": { title: string, content: [] }
// - "subdivision": { title: string, content: [] }
// - "text": { data: string | () => JSX }
// - "image": { data: string (url) }
// - "gallery": { images: [{ src, alt, credit: { name, url } }] }
// - "table": { data: [ { row: {} }]}
// - "list": { data: string (newline separated list) }
// - "component": { data: string (key to componentMap) }
// - "inlineLink": { text: string, onClick: fn }

const petsGuide = {
  id: "pets-guide",
  title: "Pet Guide",
  category: "Guides",
  slug: "pets",
  sections: [
    {
      id: "about-pets",
      title: "About",
      type: "section",
      content: [
        {
          id: "what-are-pets",
          title: "What Are Pets?",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Pets are one of the NFTs made for the Pixels Platform. Pets follow around Pixels players, require attention in game, can be fed, given water to, played with, and give some extra perks to holders.
            <br/>You can see more about those perks under <a href="./wiki/pets/types" rel="noreferrer" target="_blank">Types></a>`,
            },
          ],
        },
        {
          id: "how-to-get-pet",
          title: "How to get a Pet?",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `The team sometimes has events where a pet is a prize. You can't buy or mint a pet directly from the game at all times, but you can still purchase them from other players on the SkyMavis Marketplace. However, if you get a hatched pet, you cant change the stats. So be sure to check out stats before purchasing. If you buy a capsule, your potions can still determine the pet stats`,
            },
          ],
        },
        {
          id: "how-to-care-for-a-pet",
          title: "How to Care for a Pet?",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Pets need attention to be happy c(ꐦㅍ _ㅍ)o sometimes too much...
                <br/>There's a tracker for daily watering and daily feeding and I'll get into the details of that at the end of this.... IT'S COMPLEX, but there's more you can do!`,
            },
            {
              type: "text",
              data: `<strong> What can you do with your pet?</strong><br/>
                    <br/>🩷If it's tired and needs rest, you can give it an Energy Drink or set it to rest (Rest Pet)
                    <br/>🩷If it's hungry, you can give it Pet Treats or Popberries
                    <br/>🩷If it's thirsty, you can water your pet with the Rusty Watering Can
                    <br/>🩷If it wants to play, you can give it a Stick or if it's just bored, you can leave him out and walk around for a bit!
                    <br/>💔Grainbows make them vomit. Overfeeding also makes them vomit`,
            },
            {
              type: "text",
              data: `So here's the fun tracker part for your watering and feeding streak:
                    <br/>💫 To keep your streak going, you must water/feed after 24 hours has passed since the previous tracked feeding but before 48 hours has passed
                    <br/>💫 If you do not feed or water your pet within 24 hours, you will forfeit 1 day on your streak
                    <br/>💫 If you do not feed or water your pet within 48 hours, you will forfeit your streak`,
            },
            {
              type: "text",
              data: `Knowing the rules makes it much easier to keep track of your streak. But it can still be really confusing....
                <br/>So I'll give an example..
                <br/>⊳ Let's say you feed your pet for the first time today Saturday at 10 AM. 
                <br/> <strong>You get +1 Streak On Feeding</strong>
                <br/>📝 No other feeding will count before 10 AM on Day 2.
                <br/>⊳ Day 2, you can feed your pet again at 10AM tomorrow Sunday or until Monday 10AM for it to add +1 to the streak on the given day
                <br/>📝 If you forget to feed the pet before 10 AM Monday, but feed them before 10AM on Tuesday, you will lose 1 day (out of 365) but the streak won't be lost
                <br/>📝 If you forget to feed the pet before 10 AM Tuesday, the streak will be lost completely.
                <br/>⊳ Your Day 3 streak time will now be at the new time that you've fed the pet within the 48 hour timeframe. So if you fed your pet at 4PM, Day 3 will not set until 4PM.`,
            },
            {
              type: "text",
              data: `Here's a more visible time frame of reasonable feeding schedules:
                        <br/>⊳ Saturday 10AM
                        <br/>⊳ Sunday 10 AM
                        <br/>⊳ Monday 1PM [set new feeding time]
                        <br/>⊳ Tuesday 1PM
                        <br/>⊳ Thursday 10 AM [missed 1 day and set new feeding time]
                        <br/>⊳ Thursday 2 PM [Does nothing to the schedule]
                        <br/>⊳ Friday 9 AM [WRONG and can cause missed day if you don't feed again for the day]
                        <br/>⊳ Saturday 3PM [new feeding time]`,
            },
            {
              type: "text",
              data: `I hope this makes it clearer for someone ╰(*°▽°*)╯
                <br/><strong>Pro Tip:</strong> Keep track of when the counter changes on your pet's streaks, and use that time as a starting spot if you don't remember what time you fed/watered`,
            },
          ],
        },
        {
          id: "pet-happiness",
          title: "Pet Happiness",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Here's some basic information that I have seen about pet happiness:
                <br/>⬆️ 75% Increase if Pet is at 0% and is hungry/thirsty and just came out of resting
                <br/>⬆️ 25% Increase keeping Pet around after it has been resting and has been fed/watered, within 36 minutes
                <br/>⬆️ 30% Increase if Pet is Hungry + Eats a Pet Treat
                <br/>⬆️ 11% Increase if Pet is Hungry + Eats a Popberry
                <br/>⬆️ 24% Increase if Pet is Thirsty + Drinks Water
                <br/>⬇️ Gradual slow increase when you keep pet around when it misses you (I have witnessed around 2% per 2 minutes)
                <br/>⬇️ Happiness decreases by 15% when you rest your pet (not always, just the first time after a while)

                <br/><br/>Something that is kinda harder to track is the amount of pet % increase/decrease for when the pet is happy to be around, or when the pet wants rest.`,
            },
          ],
        },
      ],
    },
    {
      id: "pet-hatching",
      title: "Hatching",
      type: "section",
      content: [
        {
          id: "potion-types",
          title: "Potion Types",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `
                <i class="fa-solid fa-flask" style="color: #bf0d0d;"></i> Speed Potions - Chance to Increase Speed In Pets<br />
                <i class="fa-solid fa-flask" style="color: #6705a8;"></i> Strength Potions - Chance to Increase Strength in Pets<br />
                <i class="fa-solid fa-flask" style="color: #38a3e5;"></i> Luck Potions - Chance to Increase Luck, Speed and/or Strength in Pets<br /><br />
            
                <i class="fa-solid fa-flask" style="color: #a5afb6;"></i> Jumbo - Best Chance  |
                <i class="fa-solid fa-flask" style="color: #a5afb6;"></i> Large - Good Chance  |
                <i class="fa-solid fa-flask" style="color: #a5afb6;"></i> Medium - Low Chance  |
                <i class="fa-solid fa-flask" style="color: #a5afb6;"></i> Small - Lowest Chance<br /><br />
            
                It's best to use Jumbo Potions to get the highest stat chances for your pet, but if you cannot afford Jumbos, then try to use Large Potions. Small Potions should be a last resort.<br /><br />
            
                Best tip passed around on the web is to use 26 of your desired stat potion (e.g. 26 Strength, 26 Speed, 26 Luck) and then 4 of another stat. There's still a luck factor, but this is one of the highest probability options.
              `,
            },            
          ],
        },
        {
          id: "potion-recipes",
          title: "Potion Recipes",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `You can make potions on a potion table, which are a limited industry. You need 30 potions to hatch a pet, and they each take 3 minutes and 15 seconds to make (45s to add ingredients, 2m30s for the potion to brew). Every item you add also takes 0.1 Energy.`,
            },
            {
              type: "text",
              data: `The below recipes are taken from other places, and some I've tried myself but there's never a guarantee ƪ(˘⌣˘)ʃ Some are more likely than others`,
            },
            {
              type: "table",
              data: [
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#bf0d0d" }} /> Speed</>],
                  size: "Jumbo",
                  recipes: [
                    <>
                      <i class="fa-solid fa-tag fa-xs" style={{ color: "#caa0bb" }} />
                      15 Wax + 1 Cooking Mix
                      <br />
                      <i class="fa-solid fa-tag fa-xs" style={{ color: "#caa0bb" }} />
                      14 Wax + 1 Cooking Mix + 1 Slime
                      <br />
                      <i class="fa-solid fa-tag fa-xs" style={{ color: "#caa0bb" }} />
                      20 Wax + 1 Cooking mix/Honey
                      <br />
                      <i class="fa-solid fa-tag fa-xs" style={{ color: "#caa0bb" }} />1 Cooking Mix + 10 Slime + 10 Wax
                    </>,
                  ],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#bf0d0d" }} /> Speed</>],
                  size: "Large",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>10 Wax + Cooking Mix *maybe</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#bf0d0d" }} /> Speed</>],
                  size: "Medium",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>5 Cooking Mix + 1 Egg
                    <br />
                    <i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>20 Crop + Cooking Mix</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#bf0d0d" }} /> Speed</>],
                  size: "Small",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>3 Voidtonium
                    <br />
                    <i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>20 low lvl crop + 1 Cooking Mix
                    <br /><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>1 Grumpkin + 3 Honey{" "}</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#6705a8" }} /> Strength</>],
                  size: "Jumbo",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>15 Cooking Mix</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#6705a8" }} /> Strength</>],
                  size: "Large",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>10 Cooking Mix + Slime + 1 Crop</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#6705a8" }} /> Strength</>],
                  size: "Medium",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>5 Honey + 1 Cooking Mix
                    <br />
                    <i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>10 Cooking Mix + 1 Honey
                    <br /><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>6 Wax + 10 Honey{" "}</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#6705a8" }} /> Strength</>],
                  size: "Small",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>5 Honey
                    <br />
                    <i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>10 Honey</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#38a3e5" }} /> Luck</>],
                  size: "Jumbo",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>20 Wax + 1 Egg
                    <br />
                    <i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>10 Slime
                    <br />
                    <i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>15 Wax</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#38a3e5" }} /> Luck</>],
                  size: "Large",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>10 Slime
                    <br />
                    <i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>10 Wax + Cooking Mix
                    <br /><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>7 Wax + 5 Cooking Mix + 5 Eggs + 6 Honey{" "}</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#38a3e5" }} /> Luck</>],
                  size: "Medium",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>2 Cooking Mix
                    <br /><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>5 Cooking Mix + 1 Honey
                    <br /><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>5 Wax
                    <br /><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>3 Cooking Mix</>],
                },
                {
                  potion: [<><i class="fa-solid fa-flask" style={{ color: "#38a3e5" }} /> Luck</>],
                  size: "Small",
                  recipes: [<><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>1 of Any Crop/Material
                    <br /><i class="fa-solid fa-tag fa-xs" style={{color: "#caa0bb"}}/>1 Cooking Mix</>],
                },
              ],
            },
          ],
        },
        {
          id: "hatching-steps",
          title: "Hatching Steps",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<strong>Things you'll need:</strong>
              <br />
              A Growth Lab, 30 Potions and a Pet Capsule.
              <br />
              Growth Labs can be purchased from the Pet Store
              <br />
              <br />
              If you don't have a pet capsule, you can add potions to the growth lab, but there will be nothing to hatch.
              <br />
              You can also set the potions before you decide on a capsule, and have them ready beforehand, but if you move the growth lab, you'll lose the potions.
              <br />
              <br />
              <strong>What To Do:</strong>
              <br />
              Place the Growth Lab on a Speck or NFT Land that you own - if you're only a manager, it wont work. Start placing in the 30 Potions. Each one takes time to add (1
              minute) so 30 minutes total to add all the potions.
              <br />
              When all 30 Potions have been added, you can select your pet capsule that you want to hatch and a new pet shall be born!`,
            },
          ],
        },
      ],
    },
    {
      id: "pet-types",
      title: "Types",
      type: "section",
      content: [
        {
          id: "pet-attributes",
          title: "Pet Attributes",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `🐕 Pets were added to the Pixels game with very little utility. There isn't much use for them, but they're not completely useless. There are some traits on a pet that provide boosts to general gameplay like <b>Strength and Speed</b>. Even the Smart stat has some use. I'll provide that information below!
              <br/>🐰Pet Names <b>can</b> be duplicated and there's no way to change the names ( •̀ ω •́ )✧
              <br/>⚠️ Also take note that the stats are ineffective if the pet is not happy!`,
            },
            {
              type: "table",
              data: [
                {
                  attribute: "Smarts",
                  usability: "Multiplier for other stats",
                  notes: "See below in pet stats for more info!",
                },
                {
                  attribute: "Speed",
                  usability:
                    [<>Provides a wider reach for the player - the range is listed in notes, but should be expected that the range when reaching below is -1 (1 less tile)<br/>The notes were gotten with the help of P2G</>],
                  notes: [<>Without Pet - 3 Tile Reach
                      <br />1 - 19 Speed - 4 Tile Reach
                      <br />
                      20 - 59 Speed - 5 Tile Reach
                      <br />
                      60 - 89 Speed - 6 Tile Reach
                      <br />
                      90 - 100 Speed - 7 Tile Reach
                      </>],
                },
                {
                  attribute: "Strength",
                  usability: "Pet has bag space to access",
                  notes: [<>0 - 39 Strength = 3 Storage Slots
                      <br />
                      40 - 49 Strength = 4 Storage Slots
                      <br />
                      50 - 59 Strength = 5 Storage Slots
                      <br />
                      60 - 69 Strength = 6 Storage Slots
                      <br />
                      70 - 79 Strength = 7 Storage Slots
                      <br />
                      80 - 89 Strength = 8 Storage Slots
                      <br />
                      90 - 99 Strength = 9 Storage Slots
                      <br />
                      100 Strength = 12 Storage Slots</>],
                },
                {
                  attribute: "Luck",
                  usability: "Completely useless atm",
                  notes: "",
                },
                {
                  attribute: "Stage",
                  usability:
                  [<>There are only two stages - Capsule & Mature.<br/>Capsule means it hasn't been hatched yet and you can still determine stat traits with potions.</>],
                  notes: "",
                },
              ],
            },
          ],
        },
        {
          id: "pet-types-and-stats",
          title: "Pet Types and Stats",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `<div class="micro-text">Without official information, it's so difficult to find this information reliably. I got some of this from the pet guides article on Pixels Help Desk and the rest from research.<br/>
                Some Pets Have Special Stat Boosts for their "Smarts" and this is the base multiplier for other stats when hatching<br/>
                Essentially each pet has a base quality, and the smarts determines how much to multiply the potion stats by<br/>
                Speed, Strength, Luck will be abbreviated as SSL in the information below</p></div>`,
            },
            {
              type: "table",
              data: [
                {
                  type: "🦎 Coingecko",
                  amount: "17",
                  smart: "50 (2) / 40 (15)",
                  SSL: "19.53125 / 15.625",
                  tokens: [<>#4, #5<br/>#3276 - #3290</>],
                  "More Details": [<>2 Coingecko pets were given away in December 2023 as part of collaboration with their team.
                        <br/>15 Coingecko Pets were given away in April 2024 as part of a collaboration event with Coingecko.</>],
                },
                {
                  type: "🐶 Sully",
                  amount: "1",
                  smart: "50",
                  SSL: "19.53125",
                  tokens: "#3",
                  "More Details": ``,
                },
                {
                  type: "🦖 Genesis Pets",
                  amount: "246",
                  smart: "50",
                  SSL: "19.53125",
                  tokens: [<>#2, #6 - #203<br/>#206 - #253 (Team Tokens)</>],
                  "More Details": [<>200 Genesis Pets were given away in the Pixels Carnival Event in November 2023.
                                    <br/>50 more Genesis Pets were generated for giveaways and team</>],
                },
                {
                  type: "🦄 Genesis Pets",
                  amount: "3",
                  smart: "50",
                  SSL: "19.53125",
                  tokens: "#1 & #204 & #205",
                  "More Details": `3 of the 250 Genesis Pets mentioned above are Rainbow Horses`,
                },
                {
                  type: "🍡 Moca",
                  amount: "5",
                  smart: "40",
                  SSL: "15.625",
                  tokens: "#254 - #258",
                  "More Details": `5 Moca Pets were given away as part of a collaboration event with Moca for the Mocaverse Event in December/January 2024.`,
                },
                {
                  type: "🐉 Dragon",
                  amount: "7",
                  smart: "40",
                  SSL: "15.625",
                  tokens: "#259 - #265",
                  "More Details": `7 Lunar New Year Dragon pets were given away for the Chinese New Year in February 2024.`,
                },
                {
                  type: "🐕 Doggos",
                  amount: "3010",
                  smart: "25",
                  SSL: "9.765625",
                  tokens: "#266 - #3275",
                  "More Details": [<>3010 Pet Capsules could be minted for 500 $PIXEL each on February 27th 2024.
                            <br/>The First doggo (266) has stats like a special pet instead of a doggo</>],
                },
                {
                  type: "🦊 Fokx",
                  amount: "5",
                  smart: "40",
                  SSL: "15.625",
                  tokens: "#3291 - #3295",
                  "More Details": `5 OKX (Fokx) Pets given away as part of a collaboration event in August 2024.`,
                },
                {
                  type: "🐄 Cows",
                  amount: "437",
                  smart: "25",
                  SSL: "9.765625",
                  tokens: "#3296 - #3732",
                  "More Details": `300 Cow Pets for the first Barney's Bazaarn Event. There are a total of 437 Cows`,
                },
                {
                  type: "🎃 Halloween 2024",
                  amount: "100",
                  smart: "25",
                  SSL: "9.765625",
                  tokens: "#3733 - #3832",
                  "More Details": `100 Halloween Pets Released for the Halloween 2024 Event`,
                },
                {
                  type: "🐧 Penguins",
                  amount: "425",
                  smart: "25",
                  SSL: "9.765625",
                  tokens: "#3833 - #4257",
                  "More Details": `400 Penguins were announced for the Winter Carnival 2024 Event. There are 425 Penguins available`,
                },
                {
                  type: "🐍 Snakes",
                  amount: "31",
                  smart: "40",
                  SSL: "15.625",
                  tokens: "#4258 - #4288",
                  "More Details": `25 Pets Given away for the Lunar Festival 2025 Event. 31 in rotation.`,
                },
                {
                  type: "🌈 Clover Clash 2025",
                  amount: "130",
                  smart: "40 (38) / 25 (92)",
                  SSL: "15.625 / 9.765625",
                  tokens: "#4289 - #4417",
                  "More Details": `130 Pets Given away during Clover Clash Event. Partially through the event, the Smart stats were changed from 40 to 25.`,
                },{
                  type: "🍋‍🟩 Shorelime Pets",
                  amount: "6",
                  smart: "25",
                  SSL: "9.765625",
                  tokens: "#4418 - #4423",
                  "More Details": `6 Shorelime Pets Released for the Summer Solstice 2025 Event`,
                },{
                  type: "🤖 Robo Dogs",
                  amount: "30",
                  smart: "30",
                  SSL: "11.71875",
                  tokens: "#4424 - #4453",
                  "More Details": `30 Robo Dogs Could be Won from the Neon Zone Update from the Fortune Teller`,
                },{
                  type: "🦇 Halloween Bat Pets",
                  amount: "23",
                  smart: "30",
                  SSL: "11.71875",
                  tokens: "#4454 - #4476",
                  "More Details": `Multiple Bat Pets could be won via the Halloween Quest of 2025 as well as 2 Bat Pets from Bountyfall`,
                },
              ],
            },
            {
              type: "text",
              data: `Based on the above chart, there are <b>4,476 total pets</b>.<br/><br/>
              <strong>You need 30 potions to hatch a pet</strong> - these 30 Potions determine Strength, Luck and Speed. But each potion has a Point on it. <u>Jumbo potions have the best points.</u>
            <br/>I don't have the exact number of points for each potion (As soon as I find the math to it, I'll add that here)
           <br/> But the smarts multiplier determines how high of a stat you can acquire based on the potions applied. Of course there's still RNG`,
            },
          ],
        },
      ],
    },
  ],
};

export default petsGuide;
